export enum AlertType {
  Date = 'DATE',
  RecurringInterval = 'RECURRING_INTERVAL',
  Interval = 'INTERVAL',
  Min = 'MIN_VALUE',
  Max = 'MAX_VALUE',
  RoutineCompletions = 'ROUTINE_COMPLETIONS',
  DaysSkipped = 'DAYS_SKIPPED',
}

export enum AlertInputs {
  alertLabel = 'alertLabel',
  alertLabelPlaceholder = 'alertLabelPlaceholder',
  startDate = 'startDate',
  endDate = 'endDate',
  minValue = 'minValue',
  maxValue = 'maxValue',
  daysStartDate = 'daysStartDate',
  completions = 'completions',
  daysSkipped = 'daysSkipped',
  onDate = 'onDate',
  intervalRoutineId = 'intervalRoutineId',
  onInterval = 'onInterval',
  onIntervalStart = 'onIntervalStart',
  assetIntervalStarts = 'assetIntervalStarts',
  dayInterval = 'dayInterval',
  dayIntervalUnit = 'dayIntervalUnit',
}

export enum AlertTriggerConfigKeys {
  onInterval = 'onInterval',
  dayIntervalUnit = 'dayIntervalUnit',
  ceiling = 'ceiling',
  floor = 'floor',
  onCompletionCount = 'onCompletionCount',
  daysSinceCompleted = 'daysSinceCompleted',
  onDate = 'onDate',
}

export type ClearButtonProps = {
  inputType: AlertInputs;
};

export type DeleteLogicProps = ClearButtonProps;

/**
 * Imperative handle exposed by alert forms so external controls (e.g. a
 * header "Confirm" button outside the form tree) can trigger submit or reset
 * without prop-drilling through ColumnData.
 */
export type AlertFormRef = {
  handleSubmit: (fn: (data: unknown) => Promise<void>) => () => void;
  reset: () => void;
} | null;
